import React from 'react';
import { Navigate, RouteObject, useRoutes } from 'react-router-dom';

const Chat = React.lazy(() => import('./Chat'));

const ChatLayout: RouteObject[] = [
  {
    path: '/',
    element: (
      <Chat />
    ),
  },
  {
    path: ':roomId',
    element: (
      <Chat />
    ),
  },
  { path: '*', element: <Navigate to="/404" /> },
];

const ChatRoutes = () => useRoutes(ChatLayout);
export default ChatRoutes;
